/**
 * Filters Module
 * Handles filtering functionality for carousels and media
 */

import { createSwiperWithPreset } from '../utils/swiperConfig.js';
import { $$, on, exists, addClass, removeClass, toggleClass, attr, show, hide, closest, find, each } from '../utils/dom.js';

export const initCardImageSliderFilter = () => {
  if (exists(".card-image-slider-filter__swiper")) {
    const cardImageSliderFilter = createSwiperWithPreset(
      ".card-image-slider-filter__swiper",
      "standardCarousel",
      {
        autoplay: false,
        navigation: {
          nextEl: ".card-image-slider-filter__next",
          prevEl: ".card-image-slider-filter__prev",
        },
      }
    );

    on($$(".nav .nav-link"), "click", function (e) {
      e.preventDefault();

      removeClass(".nav .nav-link", "active");
      addClass(this, "active");

      const filter = attr(this, "data-section");

      each($$(".card-image-slider-filter__swiper .swiper-slide"), (slide) => {
        const section = attr(slide, "data-section");

        if (filter === "all" || section === filter) {
          show(slide);
        } else {
          hide(slide);
        }
      });

      cardImageSliderFilter.update();
    });
  }
};

export const initMediaFilters = () => {
  if (exists(".media-filters")) {
    on($$(".media-filter__current"), "click", function (e) {
      e.preventDefault();
      const currentElement = this;
      toggleClass(currentElement, "active");
      const filter = attr(currentElement, "data-filter");

      each($$(".media-filter__current"), (el) => {
        if (el !== currentElement) {
          removeClass(el, "active");
        }
      });

      const currentFilter = closest(currentElement, ".media-filter");
      const currentActionItem = find(currentFilter, ".media-filter__action-item");

      each($$(".media-filter__action-item"), (item) => {
        if (item !== currentActionItem) {
          removeClass(item, "active");
        }
      });

      if (currentActionItem) {
        toggleClass(currentActionItem, "active");
      }
    });
  }
};
